import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      domain_history: 'breadcrumb/domain',
      category_history: 'breadcrumb/category',
      subcategory_history: 'breadcrumb/subcategory',
    }),
    domainHistory: {
      get() {
        return this.domain_history ? this.domain_history : null
      },
      set(value) {
        this.setDomain(value)
      },
    },
  },

  watch: {
    $route: {
      handler(val) {
        if (this.$route.params.domain) {
          this.setDomain(this.$route.params.domain)
        }
        if (this.$route.params.category) {
          this.setCategory(this.$route.params.category)
        }
        if (this.$route.params.subcategory) {
          this.setSubCategory(this.$route.params.subcategory)
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions({
      setDomain: 'breadcrumb/setDomain',
      setCategory: 'breadcrumb/setCategory',
      setSubCategory: 'breadcrumb/setSubCategory',
    }),
  },
}
